// Canonical coach ID normalization (Frontend is authoritative)
// Maps legacy/backend IDs to the canonical frontend IDs used across UI and sessions.

const backendToFrontend: Record<string, string> = {
  // Canonical personas
  rajesh: 'rajesh',
  samuel: 'samuel',
  priya: 'priya',
  meera: 'meera',
  aisha: 'aisha',
  arjun: 'arjun',

  // Legacy/backend aliases -> canonical personas
  rohan: 'samuel',
  maya: 'priya',
  aria: 'meera',
  zara: 'aisha',

  // Historical synonyms (future-proofing; add as needed)
  // 'performance': 'rohan',
  // 'career': 'maya',
  // 'leadership': 'samuel',
};

export const normalizeCoachId = (id: string | null | undefined): string => {
  if (!id) return 'samuel';
  const key = id.trim().toLowerCase();
  return backendToFrontend[key] || key;
};

export const normalizeCoachIds = (ids: (string | null | undefined)[]): string[] => {
  return ids
    .map((id) => normalizeCoachId(id))
    .filter((v, idx, arr) => !!v && arr.indexOf(v) === idx) // de-dupe and drop empties
    .slice(0, 3);
};
